import { render } from "./ModalDialog.vue?vue&type=template&id=55270953&scoped=true&ts=true&lang=pug"
import script from "./ModalDialog.vue?vue&type=script&lang=ts"
export * from "./ModalDialog.vue?vue&type=script&lang=ts"

import "./ModalDialog.vue?vue&type=style&index=0&id=55270953&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/CMS Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55270953"]])

export default __exports__